export const followLinkAttribute = function (el) {
    const url = el.getAttribute("data-link");
    window.location.href = url;
};
